module.exports = __webpack_public_path__ + "static/media/model6.7687a25d.glb";